module.exports = __webpack_public_path__ + "img/news-3.8d1a422d.jpg";